import { FC } from 'react';

import { MarkerF as Marker } from '@react-google-maps/api';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { GOOGLE_MAPS, RETAILS_MARKERS } from '../../constants';
import MarkerIcon from './MarkerIcon';

type Props = {
    onClick: () => void;
};

export const WorldMarker: FC<Props> = ({ onClick }) => {
    const { t } = useTranslations();

    return (
        <Marker
            icon={{
                url: MarkerIcon,
                scaledSize: new google.maps.Size(RETAILS_MARKERS.size.big.width, RETAILS_MARKERS.size.big.height),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(RETAILS_MARKERS.size.big.width / 2, RETAILS_MARKERS.size.big.height),
            }}
            position={{ lat: GOOGLE_MAPS.lat, lng: GOOGLE_MAPS.lng }}
            onClick={onClick}
            title={t['faq.additional_help_section.retails']}
        />
    );
};
